<template>
  <div class="page-pay-notify-general">
    <div v-if="!isMiniWebView"
         class="page-pay-notify-general-page-header"
    >
      <div class="back">
        <ym-icon class="icon-back"
                 name="back"
                 @click="handleClickBack"
        />
      </div>
    </div>
    <div class="page-pay-notify-general-header">
      <h1 class="title">
        <span>{{ pageData.title }}</span>
        <ym-icon class="icon"
                 name="round-tick"
        />
      </h1>
      <div class="info">
        <div class="desc">{{ pageData.desc }}</div>
        <div class="sub-title">{{ pageData.subTitle }}</div>
        <div class="deadline">
          有效期至：{{ pageData.millionReadExperience.deadline | formatTime('yyyy/MM/dd HH:ii:ss') }}
        </div>
      </div>
    </div>
    <div class="page-pay-notify-general-content">
      <div class="page-pay-notify-general-content-header">
        <ym-img class="icon"
                :src="require('@/assets/img/pay_center/pay_notify_header_icon.png')"
                alt=""
        />
        <span>重要</span>
      </div>
      <div class="page-pay-notify-general-content-info">
        {{ pageData.millionReadExperience.qrCode.hint }}<br/>
        获取<span>「使用指南」</span>和更多<span>「学习辅导」</span>
      </div>
      <div v-if="inAppWebView"
           class="page-pay-notify-general-content-add-btn"
           @click="handleAppScanQrCode"
      >
        <span>马上添加</span>
        <ym-img class="icon"
                :src="require('@/assets/img/pay_center/pay_notify_add_icon.png')"
                alt=""
        />
      </div>
      <div v-else
           class="page-pay-notify-general-content-qr-code"
      >
        <ym-img class="page-pay-notify-general-content-qr-code-img"
                :src="pageData.millionReadExperience.qrCode.src"
        />
      </div>
      <div class="page-pay-notify-general-content-hint">
        如关注失败，请微信搜索「少商百万阅读」公众号进行关注
      </div>
    </div>
  </div>
</template>

<script>
  import { isAppWebView, isMiniWebView } from '@/utils';
  import { locationToAppWithRoute } from '@/utils/app-route';

  export default {
    name: 'PayNotifyGeneral',
    props: {
      pageData: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        isMiniWebView: isMiniWebView(),
      };
    },
    computed: {
      inAppWebView() {
        return isAppWebView();
      },
    },
    methods: {
      handleClickBack() {
        const { meta } = this.$route || {};
        const { back } = meta;
        if (back) {
          this.$router.replace(back);
          return;
        }
        this.$router.go(-1);
      },
      handleAppScanQrCode() {
        locationToAppWithRoute({
          name: 'AppQrCodeDetail',
          params: {
            qrCode: this.pageData.millionReadExperience.qrCode.src,
            name: this.pageData.millionReadExperience.qrCode.hint,
            hint: '获取「使用指南」和更多「学习辅导」',
          },
        });
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-pay-notify-general {
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: @background-color-base;

    &-page-header {
      width: 100%;
      height: 300px;
      background: #fed100;

      .back {
        width: 70px;
        height: 70px;
        margin: @size-base 0 0 @size-base;
      }

      .icon-back {
        margin-top: @size-base;
        color: @color-text-base;
      }
    }
    &-header {
      box-sizing: border-box;
      width: 690px;
      margin-top: -156px;
      margin-bottom: @size-small;
      padding: 0 @size-base;
      background: @color-white;
      border-radius: 12px;

      .title {
        margin: 0;
        padding: @size-extra-medium 0;
        color: @color-text-base;
        font-size: @font-size-extra-extra-large;
        font-weight: @font-weight-bold;
        line-height: 1;
        display: flex;
        align-items: center;
        justify-content: center;

        .icon {
          margin-left: @size-small;
          color: #ff8500;
          font-size: @font-size-largest;
        }
      }
      .info {
        box-sizing: border-box;
        width: 100%;
        padding: @size-base 0 @size-extra-medium 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-top: 1px solid #eee;

        .desc {
          margin-bottom: 26px;
          color: @color-text-base;
          font-size: @font-size-medium;
          font-weight: @font-weight-strong;
          line-height: 1;
        }
        .sub-title {
          color: @color-text-base;
          font-size: @font-size-large;
          font-weight: @font-weight-bold;
          line-height: 1;
        }
        .deadline {
          margin-top: 16px;
          color: @color-text-lighter;
          font-size: 26px;
          line-height: 1;
        }
      }
    }
    &-content {
      box-sizing: border-box;
      width: 690px;
      margin-top: 32px;
      padding: 56px @size-base 64px @size-base;
      background: @color-white;
      border-radius: 12px;

      &-header {
        position: relative;
        margin-bottom: 70px;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        &:after {
          position: absolute;
          left: 0;
          right: 0;
          bottom: -8px;
          margin: 0 auto;
          width: 200px;
          height: 20px;
          content: '';
          background: fade(#fed100, 20%);
          border-radius: 10px;
          z-index: 0;
        }
        .icon {
          width: 50px;
          height: 55px;
          margin-right: 22px;
        }
        span {
          position: relative;
          z-index: 2;
          color: @color-text-base;
          font-size: @font-size-largest;
          line-height: 1;
          font-weight: @font-weight-strong;
        }
      }
      &-info {
        margin-bottom: 32px;
        color: @color-text-base;
        font-size: @font-size-medium;
        line-height: 1.5;
        text-align: center;
        span {
          color: #ff8500;
          font-weight: @font-weight-strong;
        }
      }
      &-add-btn {
        width: 344px;
        height: 88px;
        margin: 0 auto 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: @color-text-base;
        font-size: @font-size-medium;
        font-weight: @font-weight-strong;
        line-height: 1.2;
        background: #fed100;
        border-radius: 44px;
        .icon {
          width: 32px;
          height: 32px;
          margin-left: 16px;
        }
      }
      &-qr-code {
        width: 200px;
        height: 200px;
        margin: 0 auto 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f5f6f7;
        border-radius: 8px;
        &-img {
          width: 180px;
          height: 180px;
        }
      }
      &-hint {
        color: @color-text-light;
        font-size: @font-size-small;
        line-height: 1.3;
        text-align: center;
      }
    }
  }
</style>
